<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="eSIM" title="Upload IMEI" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row align-items-center">
									
									<div class="col-md-2">
										<div class="btn btn-info" @click="openModal">Upload</div>
									</div>

									<div class="col-md-6"></div> <!-- Spacer (optional) -->
									<div class="col-md-2">
										<select class="form-select" v-model="status" @change="fetchSims()">
											<option value="">All</option>
											<option value="1">Pending</option>
											<option value="2">Assigned</option>
										</select>
									</div>

									<div class="col-md-2 text-end">
										<input 
											type="text" 
											class="form-control d-inline-block" 
											v-model="keyword" 
											placeholder="Search" 
											@keyup="fetchSims()" 
										/>
									</div>

								</div>
							</div>

		
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>ICCID & MSISDN</th>
											<th>Status</th>
											<th>SIM Provider</th>
											<th>Network</th>
											<th>Updated User</th>
										</tr>
									</thead>

									<tbody v-if="Boolean(simList.length)">
										<tr v-for="(sim, index) in simList" :key="sim.id" align="center">
                                            <td>{{ index + 1 }}</td>
											<td>
												<b>ICCID:-</b>{{ sim.iccid }} <br> 
												<b>MSISDN 1:-</b>{{ sim.msisdn_1 }} <br>
												<b>MSISDN 2:-</b>{{ sim.msisdn_2 }}<br>
											</td>
											<td>
												<span class="badge rounded-pill bg-success" v-if="sim.status == 2">Assigned</span>
												<span class="badge rounded-pill bg-danger" v-if="sim.status == 1">Pending</span>
											</td>
											<td>{{ sim.sim || '-' }}</td>
											<td>{{ sim.network || '-' }}</td>
											<td>{{ sim.updated_user_name || '-' }}</td>
                                        </tr>	
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available</td>
										</tr>

									</tbody>

								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(simList.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchSims(page.url + '&keyword=' + keyword  +  '&limit=' + listing_length + '&status=' + status)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="uploadFile" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12 form-group">
							<input class="form-control" type="file" accept=".xls, .xlsx" @change="handleFileUpload" ref="file" />
							<small class="text-muted">Accepted formats: .xls, .xlsx</small>
							<div v-if="uploadError" class="text-danger mt-1">{{ uploadError }}</div>
							<div v-if="selectedFile" class="mt-2">
								Selected file: {{ selectedFile.name }}
							</div>
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="!selectedFile || isUploading">
							<span v-if="isUploading">Uploading...</span>
							<span v-else>{{ button_title }}</span>
						</button>
						<button type="button" class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
	  
   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				accessories: [],
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,
				status: "",

				modal_title: "Upload Excel",
				button_title: "Upload",

				selectedSIMs: [],
            	selectAll: false,

				simList: [],
				
				// File upload related data
				selectedFile: null,
				uploadError: null,
				isUploading: false,

			};
		},
		mounted() {},

		created() {
			this.fetchSims();

		},
		watch: {
			selectedSIMs(newVal) {
			this.selectAll = newVal.length === this.simList.length
			},
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchSims(page_url = null) {
				this.getToken();
				let url = "/staffs/simList?limit=" + this.listing_length  +  "&keyword=" + this.keyword + "&status=" + this.status;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.simList = responseData.records.data;
						this.pagination = responseData.records.links;
						this.from = responseData.records.from;
						this.to = responseData.records.to;
						this.total = responseData.records.total;
						
					})
					.catch((err) => console.log(err));
			},

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},
            
			clearForm() {
				this.edit = false;
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.errors = {};
			},

			toggleSelectAll() {
				if (this.selectAll) {
					this.selectedSIMs = this.simList.map(sim => sim.id)
				} else {
					this.selectedSIMs = []
				}
			},

			handleFileUpload(event) {
				const file = event.target.files[0];
				if (file) {
					// Check file type
					if (!file.name.match(/\.(xls|xlsx)$/)) {
						this.uploadError = 'Please select an Excel file (.xls or .xlsx)';
						this.selectedFile = null;
						return;
					}
					
					// Check file size (e.g., max 5MB)
					if (file.size > 5 * 1024 * 1024) {
						this.uploadError = 'File size should not exceed 5MB';
						this.selectedFile = null;
						return;
					}

					this.selectedFile = file;
					this.uploadError = null;
				}
			},

			uploadFile() {
				if (!this.selectedFile) {
					this.uploadError = 'Please select a file first';
					return;
				}

				this.isUploading = true;
				this.uploadError = null;

				const formData = new FormData();
				formData.append('imei_file', this.selectedFile);

				this.getToken();
				this.$axios.post('/staffs/uploadImei', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'Bearer ' + this.token
					}
				})
				.then(response => {
					if (response.data.status) {
						this.$swal('Success', response.data.message, 'success');
						this.closeModal();
						this.fetchSims(); // Refresh the list
					} else {
						this.$swal('Error', response.data.message, 'error');
					}
				})
				.catch(error => {
					console.error('Upload error:', error);
					this.uploadError = error.response?.data?.message || 'Error uploading file';
					this.$swal('Error', this.uploadError, 'error');
				})
				.finally(() => {
					this.isUploading = false;
					this.selectedFile = null;
					if (this.$refs.file) {
						this.$refs.file.value = ''; // Reset file input
					}
				});
			},

		},
	};
</script>
